

function convert(numrange) 
{
  const ToInt = Number;

  const numArr = numrange.split(',');
  // console.log(numArr)
  const result = numArr.reduce((a, str) => {
    // console.log("a:" + a) ;
    if (!str.includes('-')) {
      a.push(ToInt(str));
      return a;
    }
    const [low, high] = str.split('-');
    for (let i = Number(low); i <= high; i++) {
      a.push(i);
    }
    return a;
  }, []);
  return result ;
}

module.exports = convert ;
